import { TenantPackageConfig } from '~/tenants/common/registry';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';
import dedent from 'dedent';
import McmPhotoConfig from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import McmVideoConfig, { McmVideoType } from '~/tenants/mcm/performable/video/McmVideoConfig';
import McmDroneConfig, { McmDroneType } from '~/tenants/mcm/performable/drone/McmDroneConfig';
import McmVirtualConfig from '~/tenants/mcm/performable/virtual/McmVirtualConfig';

const McmPackageCare: TenantPackageConfig<McmOrderContext> = {
  id: 'care',
  name: 'Care',
  performables: [
    McmPhotoConfig,
    McmVirtualConfig,
    {
      config: McmVideoConfig,
      metadata: {
        type: McmVideoType.HIGHLIGHT,
        social_edit: true
      },
    },
    {
      config: McmDroneConfig,
      metadata: {
        type: McmDroneType.VIDEO_PHOTO
      },
    },
  ],
  eligible: ({ buyer, parent }) => !Boolean(buyer.metadata.crossroads || parent?.crossroads),
  description: '',
  amount: '179.90'
};

export default McmPackageCare;
